<template>
    <div class="row div-spacing-top">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="order-title">
                Order Information
            </div>
            <p>
              If the lens options do not meet the needs of the patient, please complete as much of the order form as possible and check the box below to include additional information in the section for special requests.
            </p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row no-margin">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div">
                    <p class="left-padding-div">Please select the lens type from the icons below.*</p>
                </div>
                <div v-for="ld in lensType" class="col-sm center order-div">
                    <label class="g-mb-0 g-font-size-20">{{ld.description}}</label>
                    <div @click="JobTypeDependency(ld)" class="image-div g-mb-10">
                        <img v-if="Order.LensTypeCode != ld.lensCode" class="img-fluid" :src="ld.imageURL">
                        <img v-else class="img-fluid" :src="ld.invertedImageURL">
                        <input @change="JobTypeDependency(ld)" type="radio" name="lensType" :value="ld.lensCode" v-model="Order.LensTypeCode">
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-if="ValidationResult.OrderLensTypeCode" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p class="error-message" v-if="ValidationResult.OrderLensTypeCode">{{ValidationResult.OrderLensTypeCode}}</p>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                    <div class="form-group center order-div">            
                    <div class=" hide-overflow">
                        <table class="table table-borderless white-smoke-bg">
                            <thead>
                                <tr class="center">
                                    <th style="min-width:100px;">
                                    </th>
                                    <th class="g-font-size-18 th-responsive">
                                        Sphere<span v-if="!Order.DoesNotMeetRequirements">*</span> <span data-balloon="SPH (Sphere) - Spherical error, or overall power of lens is the basic part of the prescription. Sometimes, the doctor may write 'PL' or 'Plano' - In this case, select +0.00" data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                    <th class="g-font-size-18 th-responsive">
                                        Cylinder <span data-balloon="CYL (Cylinder) - Cylinder power indicates correction for astigmatism. This field will default to a negative cylinder power. Plus cylinder can be ordered by adding a + sign before the power. Sometimes, the doctor may write 'Sphere' or 'Sph' in this field. In this case, leave the cylinder and axis fields blank." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                    <th class="g-font-size-18 th-responsive">
                                        Axis<span v-if="((Order.ReCyl != null || Order.LeCyl != null) && (Order.ReCyl != '0.00' && Order.LeCyl != '0.00')) && !Order.DoesNotMeetRequirements">*</span> <span data-balloon="Axis - The axis is required for prescriptions with cylinder power. This tells the orientation of the astigmatism." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                    <th></th>
                                    <th class="g-font-size-18 th-responsive">
                                        Addition<span v-if="Order.LensTypeCode == 'BFF' &&  !Order.DoesNotMeetRequirements">*</span> <span data-balloon="ADD (Addition) - If your prescription contains ADD or Addition values, this indicates that the patient requires a bifocal lens. Since ADD power is almost always the same in both eyes, it is common for the doctor to only write this once but this should be entered in both eyes." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                    <th class="g-font-size-18 th-responsive">
                                        Seg. Height<span v-if="Order.LensTypeCode == 'BFF' &&  !Order.DoesNotMeetRequirements">*</span> <span data-balloon="Segment (Seg) Height - This is the vertical measurement in millimeters from the bottom of the lens to where the top of the addition power should begin. This field is only necessary for multifocal (bifocal or progressive) lenses. Since ADD power is almost always the same in both eyes, it is common for the doctor to only write this once but this should be entered in both eyes. If the prescription contains an Addition (ADD) but does not contain a height measurement it is recommended that you contact the eye doctor or optician to obtain these measurements but if this is not possible, leave blank. " data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="center">
                                    <td>
                                        <span>Right Eye</span>
                                        <br>
                                        <span>(RE or OD)</span>
                                    </td>
                                    <td>

                                        <rx-input minSize="-20" maxSize="20" stepSize="0.25" fixedSize="2" displayPlus="true"  v-bind:class="{ error_select: ValidationResult.OrderRESph }"  v-model="Order.ReSph"></rx-input>
                                        <!--`
                                        <multiselect v-model="Order.ReSph" v-bind:class="{ error_select: ValidationResult.OrderRESph }" :options="sphere" deselectLabel=" " selectedLabel=" "  placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                        <p class="error-message" v-if="ValidationResult.OrderRESph">{{ValidationResult.OrderRESph}}</p>
                                    </td>
                                    <td>

                                          <rx-input minSize="-10" maxSize="10" stepSize="0.25" fixedSize="2" defaultNegative="true" inputName="ReCyl"  v-model="Order.ReCyl"></rx-input>        
                                                                        
                                      <!--
                                        <multiselect v-model="Order.ReCyl" :options="cylinder" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                    </td>
                                    <td>
                                     <rx-input minSize="0" maxSize="180" stepSize="1" fixedSize="0"  v-bind:class="{ error_select: ValidationResult.OrderREAxis }"   v-model="Order.ReAxis"></rx-input>
                                        <!--
                                        <multiselect v-model="Order.ReAxis" v-bind:class="{ error_select: ValidationResult.OrderREAxis }" :options="axis" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                        <p class="error-message" v-if="ValidationResult.OrderREAxis">{{ValidationResult.OrderREAxis}}</p>
                                    </td>
                                    <td></td>
                                    <td>
                                      <rx-input minSize="0" maxSize="5" v-bind:class="{ error_select: ValidationResult.OrderREAdd }" stepSize="0.25" displayPlus="true" fixedSize="2" :disabled="!Order.LensType.isFocal"  v-model="Order.ReAdd"></rx-input>
                                        <!--
                                        <multiselect v-model="Order.ReAdd" v-bind:class="{ error_select: ValidationResult.OrderREAdd }" :disabled="!Order.LensType.isFocal" :options="addition" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                        <p class="error-message" v-if="ValidationResult.OrderREAdd">{{ValidationResult.OrderREAdd}}</p>
                                    </td>
                                    <td>
                                        <rx-input minSize="0" maxSize="40" v-bind:class="{ error_select: ValidationResult.OrderRESegHeight }" stepSize="1" fixedSize="0" :disabled="!Order.LensType.isFocal"  v-model="Order.ReSegHeight"></rx-input>
                                        <!--
                                        <multiselect v-model="Order.ReSegHeight" v-bind:class="{ error_select: ValidationResult.OrderRESegHeight }" :disabled="!Order.LensType.isFocal" :options="height" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                        <p class="error-message" v-if="ValidationResult.OrderRESegHeight">{{ValidationResult.OrderRESegHeight}}</p>
                                    </td>
                                </tr>
                                <tr class="center">
                                    <td>
                                        <span>Left Eye</span>
                                        <br />
                                        <span>(LE or OS)</span>
                                    </td>
                                    <td>
                                             <rx-input minSize="-30" maxSize="30" stepSize="0.25" fixedSize="2" displayPlus='true'  v-model="Order.LeSph" v-bind:class="{ error_select: ValidationResult.OrderLESph }"></rx-input>
                             
                                        <!--
                                        <multiselect v-model="Order.LeSph" v-bind:class="{ error_select: ValidationResult.OrderLESph }" :options="sphere" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                        <p class="error-message" v-if="ValidationResult.OrderLESph">{{ValidationResult.OrderLESph}}</p>
                                    </td>
                                    <td>
                                                 <rx-input minSize="-10" maxSize="10" stepSize="0.25" fixedSize="2"   defaultNegative="true" inputName="LeCyl"  v-model="Order.LeCyl"></rx-input>
                             
                                    <!--
                                            <multiselect v-model="Order.LeCyl" :options="cylinder" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                    </td>
                                    <td>
                                                        <rx-input minSize="0" maxSize="180" stepSize="1" fixedSize="0"  v-model="Order.LeAxis"  v-bind:class="{ error_select: ValidationResult.OrderLEAxis }"></rx-input>
                             
                                        <!--
                                        <multiselect v-model="Order.LeAxis"  v-bind:class="{ error_select: ValidationResult.OrderLEAxis }" :options="axis" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                        <p class="error-message" v-if="ValidationResult.OrderLEAxis">{{ValidationResult.OrderLEAxis}}</p>
                                    </td>
                                    <td></td>
                                    <td>
                                             <rx-input minSize="0" maxSize="5" v-bind:class="{ error_select: ValidationResult.OrderLEAdd }" stepSize="0.25" displayPlus="true" fixedSize="2" :disabled="!Order.LensType.isFocal"  v-model="Order.LeAdd"></rx-input>
                                
                                        <!--
                                        <multiselect v-model="Order.LeAdd" v-bind:class="{ error_select: ValidationResult.OrderLEAdd }" :disabled="!Order.LensType.isFocal" :options="addition" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                        <p class="error-message" v-if="ValidationResult.OrderLEAdd">{{ValidationResult.OrderLEAdd}}</p>
                                    </td>
                                    <td>
                                            <rx-input minSize="0" maxSize="40" v-bind:class="{ error_select: ValidationResult.OrderLESegHeight }" stepSize="1" fixedSize="0" :disabled="!Order.LensType.isFocal"  v-model="Order.LeSegHeight"></rx-input>
                                    
                                        <!--
                                        <multiselect v-model="Order.LeSegHeight" v-bind:class="{ error_select: ValidationResult.OrderLESegHeight }" :disabled="!Order.LensType.isFocal" :options="height" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                            <span slot="noResult">No elements found.</span>
                                        </multiselect>
                                        -->
                                        <p class="error-message" v-if="ValidationResult.OrderLESegHeight">{{ValidationResult.OrderLESegHeight}}</p>
                                    </td>
                                </tr>
                            <tr>
                                <td colspan="7">
                                    <p v-if="(Order.LeCyl>0 && Order.ReCyl< 0) || (Order.LeCyl<0 && Order.ReCyl>0)"><small style="color: red;">You have entered opposite values for left and right eye cylinder. Please confirm Rx.</small></p>
                                    <p v-if="(Order.LeSph>0 && Order.ReSph< 0) || (Order.LeSph<0 && Order.ReSph>0)"><small style="color: red;">You have entered opposite values for left and right eye sphere. Please confirm Rx.</small></p>
                                </td>
                            </tr>
                            <tr v-show="showLensStock">
                                <td colspan="2">
                                    <span class="form-check-label">
                                        <input v-model="Order.IsUsingStockLensLab" class="form-check-input" type="checkbox" v-on:click="ShowAdditionalFields(Order.IncludeAdditionalRxFields)">
                                        <span class="font-order">Use Stock lens</span> 
                                        <!-- <span data-balloon="Use Stock lens based on PCAT." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span> -->
                                    </span>
                                </td>
                                <td colspan="5">
                                </td>
                            </tr>    
                            </tbody>
                        </table>                       
                             <span class="form-check-label">
                            <input v-model="Order.IncludeAdditionalRxFields" class="form-check-input" type="checkbox" v-on:click="ShowAdditionalFields(Order.IncludeAdditionalRxFields)">
                            <span class="font-order">Show Additonal Rx fields.</span> <span data-balloon="Show fields for Prism and Optical Center." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                            </span>                    </div>
                        <div  v-if="Order.IncludeAdditionalRxFields" class=" hide-overflow">
                        <table class="table table-borderless white-smoke-bg">
                            <thead>
                                <tr class="center">
                                    <th style="min-width:100px;">
                                    </th>
                                    <th class="g-font-size-18" style="min-width:100px">
                                        Horiz. Prism <span data-balloon="Horizontal Prism - This is the amount of prismatic power, measured in prism diopters." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                    <th class="g-font-size-18" style="min-width:100px;">
                                        <!-- v-if="((Order.ReCyl != null || Order.LeCyl != null) && (Order.ReCyl != '0.00' && Order.LeCyl != '0.00')) && !Order.DoesNotMeetRequirements" -->
                                        Base <span v-if="((Order.REHorizontalPrismValue > 0 || Order.LEHorizontalPrismValue > 0)) && !Order.DoesNotMeetRequirements">*</span> <span data-balloon="Base - The direction of the prism. Four abbreviations are used for prism direction: BU = base up; BD = base down; BI = base in (toward the wearer's nose); BO = base out (toward the wearer's ear)." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                    <th></th>
                                    <th class="g-font-size-18" style="min-width:100px;">
                                        Vert. Prism <span data-balloon="Vertical Prism - This is the amount of prismatic power, measured in prism diopters." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                    <th class="g-font-size-18" style="min-width:100px;">
                                        Base <span v-if="(Order.REVerticalPrismValue > 0 || Order.LEVerticalPrismValue > 0)  && !Order.DoesNotMeetRequirements">*</span> <span data-balloon="Base - The direction of the prism. Four abbreviations are used for prism direction: BU = base up; BD = base down; BI = base in (toward the wearer's nose); BO = base out (toward the wearer's ear)." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>
                                    <th></th>
                                    <th class="g-font-size-18" style="min-width:100px;">
                                        OC Height <span data-balloon="Optical/Ocular Center height - Please note, this option is not available for multifocal orders. If necessary, provide more information in the Special Requests section" data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                                    </th>                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="center">
                                    <td>
                                        <span>Right Eye</span>
                                        <br>
                                        <span>(RE or OD)</span>
                                    </td>
                                    <td>
                                        <rx-input minSize="0.25" maxSize="5" stepSize="0.25" fixedSize="2" v-model="Order.REHorizontalPrismValue"></rx-input>
                                    </td>
                                    <td>
                                        <select v-model="Order.REHorizontalPrismDirection" v-bind:class="{ error_select: ValidationResult.OrderREHorizontalPrismDirection }" class="form-control">
                                            <option v-for="(value, key) in PrismDirection" v-bind:value="key">{{value}}</option>
                                        </select>               
                                        <p class="error-message" v-if="ValidationResult.OrderREHorizontalPrismDirection">{{ValidationResult.OrderREHorizontalPrismDirection}}</p>                                        
                                    </td>
                                    <td></td>                                    
                                    <td>
                                     <rx-input  minSize="0.25" maxSize="5" stepSize=".25" fixedSize="2" v-model="Order.REVerticalPrismValue"></rx-input>
                                    </td>
                                    <td>
                                        <select v-model="Order.REVerticalPrismDirection" v-bind:class="{ error_select: ValidationResult.OrderREVerticalPrismDirection }" class="form-control order-div">
                                            <option v-for="(value, key) in PrismDirection" v-bind:value="key">{{key}}</option>
                                        </select>          
                                        <p class="error-message" v-if="ValidationResult.OrderREVerticalPrismDirection">{{ValidationResult.OrderREVerticalPrismDirection}}</p>                                                                                
                                    </td>
                                    <td></td>
                                    <td>
                                        <rx-input minSize="0" maxSize="40" :disabled="Order.LensType.isFocal" stepSize="1" fixedSize="0" v-model="Order.REOCHeight"></rx-input>
                                    </td>
                                </tr>
                                <tr class="center">
                                    <td>
                                        <span>Left Eye</span>
                                        <br>
                                        <span>(LE or OD)</span>
                                    </td>
                                    <td>
                                        <rx-input minSize="0.25" maxSize="5" stepSize="0.25" fixedSize="2" v-model="Order.LEHorizontalPrismValue"></rx-input>
                                    </td>
                                    <td>
                                        <select v-model="Order.LEHorizontalPrismDirection" v-bind:class="{ error_select: ValidationResult.OrderLEHorizontalPrismDirection }" class="form-control">
                                            <option v-for="(value, key) in PrismDirection" v-bind:value="key">{{value}}</option>
                                        </select>
                                        <!-- <option v-for="vl in VoucherList" v-bind:value="vl">{{vl.name}}</option> -->
                                        <p class="error-message" v-if="ValidationResult.OrderLEHorizontalPrismDirection">{{ValidationResult.OrderLEHorizontalPrismDirection}}</p>
                                    </td>
                                    <td></td>                                                                        
                                    <td>
                                     <rx-input  minSize="0.25" maxSize="5" stepSize=".25" fixedSize="2" v-model="Order.LEVerticalPrismValue"></rx-input>
                                    </td>
                                    <td>
                                      <select v-model="Order.LEVerticalPrismDirection" v-bind:class="{ error_select: ValidationResult.OrderLEVerticalPrismDirection }" class="form-control order-div">
                                            <option v-for="(value, key) in PrismDirection" v-bind:value="key">{{value}}</option>
                                      </select>
                                      <p class="error-message" v-if="ValidationResult.OrderLEVerticalPrismDirection">{{ValidationResult.OrderLEVerticalPrismDirection}}</p>
                                    </td>
                                    <td></td>
                                    <td>
                                        <rx-input minSize="0" maxSize="40" :disabled="Order.LensType.isFocal" stepSize="1" fixedSize="0" v-model="Order.LEOCHeight"></rx-input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group center order-div">
                <label>Distance PD<span v-if="!Order.DoesNotMeetRequirements">*</span> </label>
                <div class="right">
                <span style="text-align: left" data-balloon="Distance PD (Pupillary Distance) - The distance in millimeters (mm) between the patient's pupils when they are looking at objects in the distance. This will either be represented with 2 numbers (separate measurements for the left and right eyes) or 1 number (a single measurement between pupils)." data-balloon-pos="up" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                </div>
                <div v-if="!Order.IsOnly1DistancePD" class="row">
                     <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>RE/OD</label>
                            <rx-input minSize="20" maxSize="40" stepSize=".50" fixedSize="1"  v-bind:class="{ error_select: ValidationResult.OrderREDistPD }"   v-model="Order.ReDistPD"></rx-input>
                                 
                            <!--
                            <multiselect v-model="Order.ReDistPD" v-bind:class="{ error_select: ValidationResult.OrderREDistPD }" :options="distancePd" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                <span slot="noResult">No elements found.</span>
                            </multiselect>
                            -->
                            <p class="error-message" v-if="ValidationResult.OrderREDistPD">{{ValidationResult.OrderREDistPD}}</p>
                        </div>
                     </div>
                     <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>LE/OS</label>
                              <rx-input minSize="20" maxSize="40" stepSize=".50" fixedSize="1"  v-bind:class="{ error_select: ValidationResult.OrderLEDistPD }"   v-model="Order.LeDistPD"></rx-input>
                         
                            <!--
                            <multiselect v-model="Order.LeDistPD" v-bind:class="{ error_select: ValidationResult.OrderLEDistPD }" :options="distancePd" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                <span slot="noResult">No elements found.</span>
                            </multiselect>
                            -->
                            <p class="error-message" v-if="ValidationResult.OrderLEDistPD">{{ValidationResult.OrderLEDistPD}}</p>
                        </div>
                     </div>
                </div>
                <div v-if="Order.IsOnly1DistancePD" class="form-group">
                    <rx-input minSize="40" maxSize="80" stepSize=".50" fixedSize="2"  v-bind:class="{ error_select: ValidationResult.OrderDistancePD }"   v-model="Order.DistancePD"></rx-input>
                 
                  <!--
                    <multiselect v-model="Order.DistancePD" v-bind:class="{ error_select: ValidationResult.OrderDistancePD }" :options="singleDistancePd" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                        <span slot="noResult">No elements found.</span>
                    </multiselect>
                    -->
                    
                    <p class="error-message" v-if="ValidationResult.OrderDistancePD">{{ValidationResult.OrderDistancePD}}</p>
                </div>
                <div class="form-check">
                    <input type="checkbox" v-model="Order.IsOnly1DistancePD" tabindex="-500" class="form-check-input" @change="ClearDistancePD">
                    <label class="form-check-label">Only 1 PD Measurement</label>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top">
            <div class="form-group center order-div">
                <label>Near PD<span v-if="Order.LensTypeCode == 'BFF'">*</span><span v-else-if="Order.DoesNotMeetRequirements"></span></label><span style="text-align: left" data-balloon="Near PD (Pupillary Distance) - The distance in millimeters (mm) between the patient's pupils when they are looking at objects close to their face. This will either be represented with 2 numbers (separate measurements for the left and right eyes) or 1 number (a single measurement between pupils). If the prescription contains an Addition (ADD) but does not contain Near PD measurements it is recommended that you contact the eye doctor or optician to obtain these measurements but if this is not possible, leave blank" data-balloon-pos="down" data-balloon-length="large" class="right"><i class="fa fa-question-circle-o"></i></span>
                <div class="row" v-if="!Order.IsOnly1NearPD">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>RE/OD</label>
                            <rx-input minSize="20" maxSize="40" stepSize=".50" fixedSize="2"  v-bind:class="{ error_select: ValidationResult.OrderRENearPD }" :disabled="!Order.LensType.isFocal"  v-model="Order.ReNearPD"></rx-input>
                    <!--
                            <multiselect v-model="Order.ReNearPD" v-bind:class="{ error_select: ValidationResult.OrderRENearPD }" :disabled="!Order.LensType.isFocal" :options="nearPd" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                <span slot="noResult">No elements found.</span>
                            </multiselect>
                    -->
                            <p class="error-message" v-if="ValidationResult.OrderRENearPD">{{ValidationResult.OrderRENearPD}}</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <div class="form-group">
                            <label>LE/OS</label>
                            <rx-input minSize="20" maxSize="40" stepSize=".50" fixedSize="2"  v-bind:class="{ error_select: ValidationResult.OrderLENearPD }"  :disabled="!Order.LensType.isFocal" v-model="Order.LeNearPD"></rx-input>
    
                            <!--
                            <multiselect v-model="Order.LeNearPD" v-bind:class="{ error_select: ValidationResult.OrderLENearPD }" :disabled="!Order.LensType.isFocal" :options="nearPd" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                                <span slot="noResult">No elements found.</span>
                            </multiselect>
                            -->
                            <p class="error-message" v-if="ValidationResult.OrderLENearPD">{{ValidationResult.OrderLENearPD}}</p>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-if="Order.IsOnly1NearPD">
                     <rx-input minSize="40" maxSize="80" stepSize=".50" fixedSize="2"  v-bind:class="{ error_select: ValidationResult.OrderNearPD }"  :disabled="!Order.LensType.isFocal" v-model="Order.NearPD"></rx-input>
    
                    <!--
                    <multiselect v-model="Order.NearPD" v-bind:class="{ error_select: ValidationResult.OrderNearPD }" :options="singleNearPd" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                        <span slot="noResult">No elements found.</span>
                    </multiselect>
                    -->
                    <p class="error-message" v-if="ValidationResult.OrderNearPD">{{ValidationResult.OrderNearPD}}</p>
                </div>
                <div class="form-check">
                    <input type="checkbox" v-model="Order.IsOnly1NearPD" v-bind:disabled="!Order.LensType.isFocal" tabindex="-500" class="form-check-input" @change="ClearNearPD">
                    <label class="form-check-label">Only 1 PD Measurement</label>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group order-div">
                <label>Lens Design<span v-if="!Order.DoesNotMeetRequirements">*</span></label>
                <img :src="pageLoader_img" height="30px" width="30px" class="pull-right" v-if="isLensDesignLoadingx">
                <multiselect v-model="Order.LensDesignObject" label="designName" :disabled="ComputedIsLensDesignDisabled" @remove="RemoveLensDesign()" @close="LensDesignDependency(Order.LensDesignObject.designCode, Order.LensMaterialObject.code)"  v-bind:class="{ error_select: ValidationResult.OrderLensDesign }" :options="lensDesign" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" " :preselect-first="true">
                    <span slot="noResult">No elements found.</span>
                </multiselect>
                <p class="error-message" v-if="ValidationResult.OrderLensDesign">{{ValidationResult.OrderLensDesign}}</p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group order-div order-div">
                <label>Lens Material<span v-if="!Order.DoesNotMeetRequirements">*</span> <span style="text-align: left" data-balloon="All standard lenses provided are polycarbonate" data-balloon-pos="up" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span></label>
                <img :src="pageLoader_img" height="30px" width="30px" class="pull-right" v-if="isLensMaterialLoadingx">
                <span v-if="isLensDesignLoading" class="loading_icon"><img src="../../../../../static/img/loading.gif" style="width: 25px"/></span>
                <multiselect v-model="Order.LensMaterialObject" label="name" :disabled="lensMaterial.length == 0" @remove="RemoveMaterial()" @input="LensMaterialDependency(Order.LensDesignObject.designCode, Order.LensMaterialObject.code)"  v-bind:class="{ error_select: ValidationResult.OrderLensMaterial }" :options="lensMaterial" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                    <span slot="noResult">No elements found.</span>
                </multiselect>
                <p class="error-message" v-if="ValidationResult.OrderLensMaterial">{{ValidationResult.OrderLensMaterial}}</p>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row no-gutters">
                <div v-if="MasterAccountType != 'master'" v-bind:class="{ disable: Order.LensDesign == null}" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div left-padding-div">
                    <span class="form-label">
                        Lens Treatment(s)
                    </span>
                    <span v-if="isLensMaterialLoading || isCompatibleLoading" class="loading_icon"><img src="../../../../../static/img/loading.gif" style="width: 25px"/></span>
                    <div v-for="lt in lensTreatment" class="form-check">
                        <span class="form-check-label">
                            <input v-bind:disabled="isCompatibleLoading" v-model="Order.LensTreatment" v-bind:value="lt.code" v-on:click="GetCompatability(lt.code)" class="form-check-input" type="checkbox">
                            <span class="font-order">{{lt.description}}</span>
                        </span>
                    </div>
                </div>
                <div v-if="MasterAccountType == 'master'" class="col-lg-8 col-md-8 col-sm-12 col-xs-12 div-spacing-top order-div left-padding-div">
                    <label>Lens Treatment(s)</label>
                    <span v-if="isLensMaterialLoading || isCompatibleLoading" class="loading_icon"><img src="../../../../../static/img/loading.gif" style="width: 25px"/></span>
                    <multiselect v-model="selectedLensTreatment" @remove="RemoveLensTreatment" @select="AddLensTreatment" label="description" track-by="code" :options="lensTreatment" :disabled="isCompatibleLoading" :hideSelected="true" :multiple="true" deselectLabel=" " selectedLabel=" " placeholder=" " selectLabel=" ">
                        <span slot="noResult">No elements found.</span>
                    </multiselect>
                </div>
                <div v-if="MasterAccountType == 'master'" class="col-lg-4 col-md-4 col-sm-12 col-xs-12 div-spacing-top order-div left-padding-div">
                </div>
                <div v-if="MasterAccountType == 'master'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
                    <div class="row no-gutters order-div">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="form-group">
                                <label>Lens Treatment Comments</label>
                                <textarea v-model="Order.LensTreatmentComment" row="3" class="form-control"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
            <div class="row no-gutters">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 order-div g-px-10">
                    <span class="form-label div-spacing-bottom">
                        Special Requests/Instructions
                    </span>                    
                    <div class="form-check">
                        <span class="form-check-label">
                            <input v-model="Order.DoesNotMeetRequirements" class="form-check-input" type="checkbox" v-on:click="SpecialOrder(Order.DoesNotMeetRequirements)">
                            <span class="font-order">The lens options above do not meet the medical needs of this patient.</span> <span data-balloon="If the above options do not meet the medical needs of the patient, a special request can be made by clicking this check box and completing the special request fields.  All special requests are subject to approval." data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span>
                        </span>
                    </div>
                    <div v-if="Order.DoesNotMeetRequirements" class="form-group">
                        <textarea v-model="Order.SpecialInstructions1" placeholder="What is the special request and why is it needed?" class="form-control" rows="3"></textarea>
                    </div>
                    <p class="font-order" v-if="Order.DoesNotMeetRequirements">
                        Special orders will be reviewed by the OneSight EssilorLuxottica Foundation support team in order to approve or decline the request. Special orders will take extra time to process due to this review
                    </p>
                    <div v-if="Order.DoesNotMeetRequirements" class="form-check">
                        <span class="form-check-label">
                            <input v-model="Order.IsSpecialOrderNecessary" class="form-check-input" type="checkbox" value="">
                            <span class="font-order">I attest that this special order request is medically necessary for the patient.*</span>
                        </span>
                         <p class="error-message" v-if="ValidationResult.OrderIsSpecialOrderNecessary">{{ValidationResult.OrderIsSpecialOrderNecessary}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Multiselect from 'vue-multiselect'
import RxInput from './RxInput.vue'
export default {
    components:{Multiselect, RxInput},
    props:["Order", "PrismDirection", "ValidationResult", "MasterAccountType"],
    data(){
        return{
            stock_Lens_Account_Number__c: "",
            stock_Lens_Lab_Assignment__c: "",
            stock_Lens_Lab_Bill_To__c: "",
            stock_Lens_Lab_ID__c: "",
            stock_Lens_Lab_PCAT__c: "",
            stock_Lens_Lab_Ship_To__c: "",
            stock_Lens_Lab_Ship_to_Override__c: "",
            // IsUsingStockLensLab: false,
            showLensStock: false,
            sphere:[],
            cylinder:[],
            axis:[],
            addition:[],
            height:[],
            distancePd:[],
            nearPd:[],
            isOneDistance:false,
            isOneNear: false,
            lensDesign:[],
            lensType:[],
            lensMaterial:[],
            lensTreatment:[],
            lensTreatmentMaster:[],
            singleDistancePd:[],
            singleNearPd:[],
            isDisabled:false,
            isLensDesignLoading: false,
            isLensMaterialLoading: false,
            incompatabilityList:[],
            lensTreatmentLength:0,
            selectedLensTreatment:[],
            isCompatibleLoading:false,
            lensSuggestionTimeout: null,
            lensTreatmentTimeout: null,
            lensMaterialTimeout: null,
            isLensDesignDisabled: false,
            isLensDesignLoadingx: false,
            isLensMaterialLoadingx: false,
            Order_DistancePD: null,
            gg: null,
        }
    },
    computed: {
        ComputedDistancePD() {
          return this.Order.DistancePD;
        },
        ComputedNearPD() {
          return this.Order.NearPD;
        },
        ComputedLeSph() {
          return this.Order.LeSph;
        },
        ComputedReSph() {
          return this.Order.ReSph;
        },
        ComputedLeCyl() {
          return this.Order.LeCyl;
        },
        ComputedReCyl() {
          return this.Order.ReCyl;
        },
        ComputedLeAdd() {
          return this.Order.LeAdd;
        },
        ComputedReAdd() {
          return this.Order.ReAdd;
        },
        ComputedLensDesignObject() {
          return this.Order.LensDesignObject;
        },
        ComputedIsLensDesignDisabled() {
          return this.isLensDesignDisabled || (this.lensDesign.length == 0);
        }
    },
    watch: {
        lensTreatment(val){
            if(val.length == 1){
                this.selectedLensTreatment = val[0];
            }
        },
        lensDesign(val){
            if(val.length == 1){
                this.Order.LensDesignObject = val[0];
                this.Order.LensDesign = val[0].designCode;
                this.GetMaterialSuggestion();
            }
        },
        lensMaterial(val){
            if(val.length == 1){
                this.Order.LensMaterialObject = val[0];
                this.Order.LensMaterial = val[0].code;
            }
            this.Order.LensTreatment = [];
            this.LensMaterialDependency(this.Order.LensDesignObject.designCode, this.Order.LensMaterialObject.code)
        },
        ComputedDistancePD: {
          immediate: true,
          handler(val) {
              this.Order.DistancePD = val;
                if(val>0){
                    let minSize = 20
                    let maxSize = 40
                    let stepSize = 0.50
                    let fixedSize = 1
                    let half = val/2
                    let unrounded = Math.min(Math.max(half, minSize), maxSize);

                    this.Order.ReDistPD = unrounded
                    this.Order.LeDistPD = unrounded
                }
          }
        },
        ComputedNearPD: {
            immediate: true,
          handler(val) {
              this.Order.NearPD = val;
                if(val>0){
                    let minSize = 20
                    let maxSize = 40
                    let stepSize = 0.50
                    let fixedSize = 2
                    let half = val/2
                    let unrounded = Math.min(Math.max(half, minSize), maxSize);

                    this.Order.LeNearPD = unrounded
                    this.Order.ReNearPD = unrounded
                }
          }
        },
        ComputedLeSph: {
          immediate: true,
          handler(val) {
              this.CheckIfLensSpecsIsCompleted();
              if (this.lensSuggestionTimeout) {
                  clearTimeout(this.lensSuggestionTimeout);
              }
              this.isLensDesignDisabled = true;
              this.lensSuggestionTimeout = setTimeout(() => this.GetLensDesignSuggestion(), 1000);
          }
        },
        ComputedReSph: {
            immediate: true,
          handler(val) {
              this.CheckIfLensSpecsIsCompleted();
              if (this.lensSuggestionTimeout) {
                  clearTimeout(this.lensSuggestionTimeout);
            }
            this.isLensDesignDisabled = true;
            this.lensSuggestionTimeout = setTimeout(() => this.GetLensDesignSuggestion(), 1000);
          }
        },
        ComputedLeCyl: {
          immediate: true,
          handler(val) {
            this.CheckIfLensSpecsIsCompleted();
            if (this.lensSuggestionTimeout) {
              clearTimeout(this.lensSuggestionTimeout);
            }

            this.lensSuggestionTimeout = setTimeout(() => this.GetLensDesignSuggestion(), 2000);
          }
        },
        ComputedReCyl: {
          immediate: true,
          handler(val) {
            this.CheckIfLensSpecsIsCompleted();
            if (this.lensSuggestionTimeout) {
              clearTimeout(this.lensSuggestionTimeout);
            }

            this.lensSuggestionTimeout = setTimeout(() => this.GetLensDesignSuggestion(), 2000);
          }
        },
        ComputedLeAdd: {
          immediate: true,
          handler(val) {
            if (this.lensSuggestionTimeout) {
              clearTimeout(this.lensSuggestionTimeout);
            }

            this.lensSuggestionTimeout = setTimeout(() => this.GetLensDesignSuggestion(), 2000);
          }
        },
        ComputedReAdd: {
          immediate: true,
          handler(val) {
            if (this.lensSuggestionTimeout) {
              clearTimeout(this.lensSuggestionTimeout);
            }

            this.lensSuggestionTimeout = setTimeout(() => this.GetLensDesignSuggestion(), 2000);
          }
        },
        ComputedLensDesignObject(val) {
            if (val.designCode == null) {
              this.lensMaterial = [];
            }
        },
    },
    methods: {
        async CheckIfLensSpecsIsCompleted(){
            console.log('LensType :>> ', this.Order.LensType);
            console.log('LensTypeCode :>> ', this.Order.LensTypeCode);
            console.log('LensLabPCAT :>> ', this.stock_Lens_Lab_PCAT__c);
            if((this.Order.LensTypeCode != null &&  this.Order.LensTypeCode != '' && this.Order.LensTypeCode == "SV") && (this.Order.ReSph != null) && (this.Order.LeSph != null)){
                let ReCyl = (this.Order.ReCyl == null) ? "0.00" : this.Order.ReCyl;
                let LeCyl = (this.Order.LeCyl == null) ? "0.00" : this.Order.LeCyl;
                ReCyl = ReCyl.replace(/\+/,'');
                LeCyl = LeCyl.replace(/\+/,'');
                let ReSph = this.Order.ReSph.replace(/\+/,'');
                let LeSph = this.Order.LeSph.replace(/\+/,'');
                
                console.log('ReCyl :>> ', ReCyl);
                console.log('LeCyl :>> ', LeCyl);

                var LensValue = await this.GetLensPcat(this.stock_Lens_Lab_PCAT__c, ReSph, ReCyl, LeSph, LeCyl)
                console.log(LensValue);
                // console.log('stock_Lens_Lab_PCAT__c :>> ', this.stock_Lens_Lab_PCAT__c);
                // console.log('stock_Lens_Lab_PCAT SQLLensValue :>> ', LensValue);
                if(((ReSph == LeSph) && (LeCyl == ReCyl)) && LensValue && (LensValue.length > 0)){
                    this.showLensStock = true;
                    this.Order.IsUsingStockLensLab = true;
                } else if(LensValue && (LensValue.length > 1)){
                    this.showLensStock = true;
                    this.Order.IsUsingStockLensLab = true;
                } else {
                    this.Order.IsUsingStockLensLab = false;
                    this.showLensStock = false;
                }
                
                // var LensValue = await this.GetLensPcat("379", "-2.25",  "-1.25",  "-2",  "-2", )
            } else {
                    this.Order.IsUsingStockLensLab = false;
                    this.showLensStock = false;
            }
        },
        GetLensPcat(code, reSph, reCyl, leSph, leCyl){
            // var _this = this;
            var url = "/Order/Catalog/LensPcat/Code/"+ code +"/re/"+ reSph + "/" + reCyl + "/le/" + leSph + "/" + leCyl
            return new Promise((resolve, reject)=>{
                axios.get(url, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                    .then(function (response) {
                        resolve(response.data.raw);
                    })
                    .catch(function (error) {
                        console.log('ERROR:', error);
                        reject({error:error});
                    });
            })
        },
        ClearDistancePD(e){
            if(this.Order.IsOnly1DistancePD == false)
                this.Order.DistancePD = null
        },
        ClearNearPD(e){
            if(this.Order.IsOnly1NearPD == false)
                this.Order.NearPD = null
        },
        AddLensTreatment(retVal){
            //var index = this.lensTreatment.findIndex(x => x.code == retVal.code);
            this.GetCompatability(retVal.code);
            this.Order.LensTreatment.push(retVal.code);
        },
        RemoveLensDesign(){
            this.Order.LensDesign = null;
        },
        RemoveMaterial(){
            this.Order.LensMaterial = null;
        },
        SpecialOrder(value){
            this.Order.IsSpecialOrderNecessary = false
        },
        ShowAdditionalFields(value){
            this.IncludeAdditionalRxFields = false
        },        
        RemoveLensTreatment(retVal){
                var index = this.Order.LensTreatment.findIndex(x => x.code == retVal.code);
                this.GetCompatability(retVal.code);
                this.Order.LensTreatment.splice(index, 1);
        },
        Reset(){
            this.lensTreatment = [];
            for(var i = 0; i < this.lensTreatmentMaster.length; i++){
                this.lensTreatment.push(this.lensTreatmentMaster[i]);
            }
            this.selectedLensTreatment = [];
        },
        OneDistancePD(){
            this.Order.IsOnly1DistancePD = !this.Order.IsOnly1DistancePD;
        },
        OneNearPD(){
            this.Order.IsOnly1NearPD = !this.Order.IsOnly1NearPD;
        },
        GetValues(start, end, increment, isPositiveDisplay, isInteger){
            var currentVal = start;
            var retVal = [];
            if(isInteger == false){

                retVal.push(currentVal.toFixed(2));
            }else{
                retVal.push(currentVal);
            }
            while(currentVal < end){
                currentVal = currentVal + increment;
                if(currentVal <= 0){
                    if(isInteger == false){
                        retVal.push(currentVal.toFixed(2));
                    }else{
                        retVal.push(currentVal);
                    }
                }else{
                    if(isPositiveDisplay){
                        if(isInteger == false){
                            retVal.push("+" + currentVal.toFixed(2));
                        }else{
                            retVal.push("+" + currentVal);
                        }
                    }else{
                        if(isInteger == false){
                            retVal.push(currentVal.toFixed(2));
                        }else{
                            retVal.push(currentVal);
                        }
                    }
                }
            }
            return retVal;
        },
        ResetNonBifocalVal(value){
            if(value === 'SV'){
                this.Order.ReAdd = null;
                this.Order.ReSegHeight =null;
                this.Order.LeAdd = null;
                this.Order.LeSegHeight = null;
                this.Order.ReNearPD = null;
                this.Order.LeNearPD = null;
                this.Order.NearPD = null;
            }
        },
        SetLensTreatmentValuesMaster(){
            for(var i = 0; i < this.lensTreatment.length; i++){
                var currentLensTreatmentCode = this.lensTreatment[i].code;
                for(var j = 0; j < this.Order.LensTreatment.length; j++){
                    if(currentLensTreatmentCode == this.Order.LensTreatment[j]){
                        this.selectedLensTreatment.push(this.lensTreatment[i]);
                        this.GetCompatability(this.lensTreatment[i].code);
                    }
                }
            }
        },
        SetLensTreatmentValuesNormal(){
            for(var i = 0; i < this.lensTreatment.length; i++){
                var currentLensTreatmentCode = this.lensTreatment[i].code;
                for(var j = 0; j < this.Order.LensTreatment.length; j++){
                    if(currentLensTreatmentCode == this.Order.LensTreatment[j]){
                        this.GetCompatability(this.lensTreatment[i].code);
                    }
                }
            }
        },
        GetLensType(){
            var _this = this;
            axios.get('/Order/Catalog/ListLensType', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.lensType = response.data.raw;
                    if(_this.Order.LensTypeCode){
                         var index = _this.lensType.findIndex(x => x.lensCode == _this.Order.LensTypeCode);
                        _this.Order.LensType = _this.lensType[index];
                    }
                    if(!(_this.Order.isFirstLoad)){
                        _this.JobTypeDependency(_this.Order.LensType);
                    }
                })
                .catch(function (error) {
                console.log('ERROR:', error);
                });
        },
        JobTypeDependency(value){
            this.Order.LensType = value;
            this.Order.LensTypeCode = value.lensCode;
            this.CheckIfLensSpecsIsCompleted();
            if(!this.Order.isFirstLoad){
                this.Order.LensMaterialObject = {code:null};
                this.Order.LensDesignObject ={designCode:null};
            }
            if (this.Order.ReSph || this.Order.LeSph || this.Order.ReCyl || this.Order.LeCyl || this.Order.ReAdd || this.LeAdd) {
                this.GetLensDesignSuggestion();
            }
            else {
                this.GetLensDesign(value.lensCode, null);
            }
            //this.GetLensMaterial(this.Order.LensDesign);
        },
        LensDesignDependency(lensDesign, lensMaterial){
            this.Order.LensDesign = lensDesign;
            this.Order.LensMaterialObject = {code:null};
            this.Order.LensMaterial = null;
            this.lensTreatment = [];
            this.lensMaterial = [];
            if (lensDesign) {
                if (this.Order.ReSph || this.Order.LeSph || this.Order.ReCyl || this.Order.LeCyl || this.Order.ReAdd || this.LeAdd) {
                    this.GetMaterialSuggestion();
                }
                else {
                    this.GetLensMaterial(lensDesign);
                }
            }
            // }else{
            //     this.GetLensTreatment(lensDesign, lensMaterial);
            // }
        },
        LensMaterialDependency(lensDesign, lensMaterial){
            // this.Order.LensTreatment = [];
            this.Order.LensMaterial = lensMaterial;
            if(!lensDesign){
                this.GetLensDesign(this.Order.LensTypeCode, lensMaterial);
            }else{
                this.GetLensTreatmentWrapper(lensDesign, lensMaterial);
            }
        },
        GetLensDesign(value, value2){
            var _this = this;
            axios.get('/Order/Catalog/ListLensDesign/' + value + '/' + value2, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.lensDesign = response.data.raw;
                    _this.ResetNonBifocalVal(value);
                    if(_this.Order.isFirstLoad){
                         var index = _this.lensDesign.findIndex(x => x.designCode == _this.Order.LensDesign);
                        _this.Order.LensDesignObject = _this.lensDesign[index];
                        if(index === -1){
                            _this.Order.LensDesignObject = {designCode:null}
                        }
                        _this.GetLensMaterial(_this.Order.LensDesign);
                    }
                })
                .catch(function (error) {
                    console.log('ERROR:', error);
                });
        },
        GetLensDesignSuggestion() {
            var _this = this;
            // _this.lensDesign = [];
            _this.isLensDesignDisabled = true;
            if (_this.Order.LensTypeCode && (_this.Order.ReSph || _this.Order.LeSph || this.Order.ReCyl || this.Order.LeCyl || this.Order.ReAdd || this.LeAdd)) {
            _this.isLensDesignLoadingx = true;

                axios.post('/Order/Catalog/ListLensDesignSuggestions', { prescription: _this.Order, lensType: _this.Order.LensTypeCode, materialCode: null } , {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                    .then(function (response) {
                        if (response.data && response.data.raw) {
                            _this.lensDesign = response.data.raw;
                            _this.ResetNonBifocalVal(_this.Order.LensTypeCode);
                            var index = _this.lensDesign.findIndex(x => x.designCode == _this.Order.LensDesign);
                                _this.isLensDesignDisabled = false;
                                _this.isLensDesignLoadingx = false;
                            if(_this.Order.isFirstLoad){
                                var index = _this.lensDesign.findIndex(x => x.designCode == _this.Order.LensDesign);
                                _this.Order.LensDesignObject = _this.lensDesign[index];
                                _this.isLensDesignDisabled = false;
                                _this.isLensDesignLoadingx = false;
                                if(index == -1){
                                    _this.Order.LensDesignObject = {designCode:null}
                                }
                                _this.GetMaterialSuggestion();
                            }
                            else {
                              if (index == -1) {
                                  _this.Order.LensDesignObject = { designCode: null };
                              } else {
                                  _this.GetMaterialSuggestion();
                              }
                            }
                            // _this.lensMaterial = [];
                            // _this.Order.LensMaterialObject = {code:null};
                            // _this.Order.LensDesignObject ={designCode:null};
                            // _this.Order.LensDesign = null;
                            // _this.Order.LensMaterial = null;
                            // _this.Order.LensTreatment = [];
                            // _this.lensTreatment = [];
                        }

                    })
                    .catch(function (error) {
                        console.log('ERROR:', error);
                        _this.isLensDesignLoadingx = false;
                    });
            }
            else {
                if (_this.Order.LensTypeCode) {
                    _this.GetLensDesign(_this.Order.LensTypeCode, null);
                }
                _this.Order.LensMaterialObject = {code:null};
                _this.Order.LensDesignObject = {designCode:null}
            } 

            // }, 5000);
        },
        GetLensMaterial(value){
            var _this = this;
            _this.isLensDesignLoading = true;
            axios.get('/Order/Catalog/ListMaterial/' + value, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.lensMaterial = response.data.raw;
                    _this.isLensDesignLoading = false;
                    if(_this.Order && _this.Order.isFirstLoad){
                        var index = _this.lensMaterial.findIndex(x => x.code == _this.Order.LensMaterial);
                        _this.Order.LensMaterialObject = _this.lensMaterial[index];
                        if(index == -1){
                            _this.Order.LensMaterialObject = {code:null}
                        }
                        _this.GetLensTreatmentWrapper(_this.Order.LensDesign, _this.Order.LensMaterial);
                    }
                })
                .catch(function (error) {
                    _this.isLensDesignLoading = false;
                    console.log('ERROR:', error);
                });
        },
        GetMaterialSuggestion() {
            var _this = this;
            _this.isLensMaterialLoadingx = true;
            axios.post('/Order/Catalog/ListMaterialSuggestions', { prescription: _this.Order, lensType: _this.Order.LensTypeCode, designCode: _this.Order.LensDesignObject ? _this.Order.LensDesignObject.designCode : null } , {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.isLensMaterialLoadingx = false;
                    if (response.data && response.data.raw) {
                        _this.lensMaterial = response.data.raw;
                        _this.isLensDesignLoading = false;
                        var index = _this.lensMaterial.findIndex(x => x.code == _this.Order.LensMaterial);
                        if(_this.Order && _this.Order.isFirstLoad){
                            _this.Order.LensMaterialObject = _this.lensMaterial[index];
                            if(index == -1){
                                _this.Order.LensMaterialObject = {code:null}
                            }
                            _this.GetLensTreatmentWrapper(_this.Order.LensDesign, _this.Order.LensMaterial);
                        }
                        else {
                            if(index == -1){
                                _this.Order.LensMaterialObject = {code:null}
                            }
                            // else {
                            //     _this.GetLensTreatmentWrapper(_this.Order.LensDesign, _this.Order.LensMaterial);
                            // }
                        }
                        // _this.lensMaterial = response.data.raw;
                        //
                        // var materialExist = false;
                        // if (_this.lensMaterial && _this.Order.LensMaterialObject) {
                        //     for(var i = 0; i < _this.lensMaterial.length; i++) {
                        //         var material = _this.lensMaterial[i];
                        //         if (material.code == _this.Order.LensMaterialObject.code){
                        //             materialExist = true;
                        //         }
                        //     }
                        //
                        //     if (!materialExist) {
                        //         _this.Order.LensMaterialObject = null;
                        //     }
                        // }
                    }

                    // if(_this.Order.isFirstLoad){
                    //     var index = _this.lensMaterial.findIndex(x => x.code == _this.Order.LensMaterial);
                    //     _this.Order.LensMaterialObject = _this.lensMaterial[index];
                    //     if(index == -1){
                    //         _this.Order.LensMaterialObject = {code:null}
                    //     }
                    //     _this.GetLensTreatment(_this.Order.LensDesign, _this.Order.LensMaterial);
                    // }
                })
                .catch(function (error) {
                    _this.isLensMaterialLoadingx = false;
                    console.log('ERROR:', error);
                });
        },
        GetMaterialSuggestionWrapper() {
            if (this.lensMaterialTimeout) {
                clearTimeout(this.lensMaterialTimeout);
            }

            this.lensMaterialTimeout = setTimeout(() => this.GetMaterialSuggestion(), 2000);
        },
        GetLensTreatment(value, value2){
            var _this = this;
            _this.isLensMaterialLoading = true;
            if(value && value2){
                axios.get('/Order/Catalog/ListTreatment/' + value + "/" + value2, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    var retVal = response.data.raw;
                    if(retVal == null){
                        retVal = [];
                    }
                    _this.lensTreatment = _this.Clone(retVal);
                    _this.lensTreatmentMaster = _this.Clone(retVal);
                    if(_this.Order && _this.Order.isFirstLoad == false){
                        if(_this.MasterAccountType == 'master'){
                          _this.Reset();
                          _this.Order.LensTreatment = [];
                        }
                    }else{
                        if(_this.MasterAccountType == 'master'){
                            _this.SetLensTreatmentValuesMaster();
                        }else{
                            _this.SetLensTreatmentValuesNormal();
                        }
                    }
                    _this.isLensMaterialLoading = false;
                    _this.Order.isFirstLoad = false;
                })
                .catch(function (error) {
                    _this.isLensMaterialLoadingx = false;
                    _this.isLensMaterialLoading = false;
                    console.log('ERROR:', error);
                });
            }
        },
        GetLensTreatmentWrapper(code1, code2) {
            if (this.lensTreatmentTimeout) {
                clearTimeout(this.lensTreatmentTimeout);
            }

            this.lensTreatmentTimeout = setTimeout(() => this.GetLensTreatment(code1, code2), 3000);
        },
        GetCompatability(code){
            var _this = this;
            this.isCompatibleLoading = true;
            var isCompatible = this.incompatabilityList.findIndex(x => x.lensCode == code);
            if(isCompatible == -1){
                axios.get('/Order/Catalog/ListIncompatibleTreatment/' + code, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
                .then(function (response) {
                    _this.isCompatibleLoading = false
                        _this.incompatabilityList.push({lensCode: code, list: response.data.raw});
                        _this.lensTreatment = _this.FilterCompatability(response.data.raw, _this.lensTreatment);
                })
                .catch(function (error) {
                console.log('ERROR:', error);
                });
            }else{
                this.incompatabilityList.splice(isCompatible, 1);
                var concatOfList = [];
                var tempArray =[];
                for(var i = 0; i < this.incompatabilityList.length; i ++){
                    concatOfList = concatOfList.concat(this.incompatabilityList[i].list);
                }
                concatOfList.filter(function(item){
                    var i = tempArray.findIndex(x => x.incompatableTreatmentCode == item.incompatableTreatmentCode);
                    if(i <= -1){
                            tempArray.push(item);
                    }
                    return null;
                });
                concatOfList = tempArray;
                var newList = this.FilterCompatability(concatOfList, this.lensTreatmentMaster);
                this.lensTreatment = newList;
                this.isCompatibleLoading = false
            }
        },
        FilterCompatability(incompatibleList, lensTreatment){
            var clonedLensTreatment = this.Clone(lensTreatment);
            for(var i = 0; i < incompatibleList.length; i++){
                var index = clonedLensTreatment.findIndex(x => x.code == incompatibleList[i].incompatableTreatmentCode);
                if(index >= 0){
                    clonedLensTreatment.splice(index, 1);
                }
            }
            return clonedLensTreatment;
        },
        Clone(array){
            var tempArray = [];
            for(var i = 0; i < array.length; i++){
                tempArray.push(array[i]);
            }
            return tempArray;
        }
    },
    created(){
        this.stock_Lens_Account_Number__c = localStorage.getItem("stock_Lens_Account_Number__c");
        this.stock_Lens_Lab_Assignment__c = localStorage.getItem("stock_Lens_Lab_Assignment__c");
        this.stock_Lens_Lab_Bill_To__c = localStorage.getItem("stock_Lens_Lab_Bill_To__c");
        this.stock_Lens_Lab_ID__c = localStorage.getItem("stock_Lens_Lab_ID__c");
        this.stock_Lens_Lab_PCAT__c = localStorage.getItem("stock_Lens_Lab_PCAT__c");
        if (this.stock_Lens_Lab_PCAT__c === '') this.stock_Lens_Lab_PCAT__c = null;
        this.stock_Lens_Lab_Ship_To__c = localStorage.getItem("stock_Lens_Lab_Ship_To__c");
        this.stock_Lens_Lab_Ship_to_Override__c = localStorage.getItem("stock_Lens_Lab_Ship_to_Override__c");

        if(!this.Order.LensTypeCode && !this.Order.LensDesign && !this.Order.LensMaterial){
            this.Order.isFirstLoad = false;
        }
        this.GetLensType();
        this.sphere = this.GetValues(-20.00, 20.00, 0.25, true, false).reverse();
        this.cylinder = this.GetValues(-10.00, 0.00, 0.25, false, false);
        this.axis = this.GetValues(0, 180, 1, false, true);
        this.addition = this.GetValues(0, 5, 0.25, false, false);
        this.height = this.GetValues(0, 40, 1, false, false);
        this.distancePd = this.GetValues(20, 40, 0.5, false, false);
        this.singleDistancePd = this.GetValues(40, 80, 0.5, false, false);
        this.nearPd = this.GetValues(20, 40, 0.5, false, false);
        this.singleNearPd = this.GetValues(40, 80, 0.5, false, false);
        if(this.Order.LensDesign && this.Order.LensMaterial){
            // if (this.Order.LensTypeCode && (this.Order.ReSph || this.Order.LeSph || this.Order.ReCyl || this.Order.LeCyl || this.Order.ReAdd || this.LeAdd)) {
            //     this.GetLensDesignSuggestion();
            // }
            // else {
            this.lensSuggestionTimeout = setTimeout(() => this.GetLensDesign(this.Order.LensTypeCode, this.Order.LensMaterial), 2000);
            // }
        }
        this.CheckIfLensSpecsIsCompleted();
    },
}
</script>




// WEBPACK FOOTER //
// OrderInformation.vue?37786cd6